<script setup lang="ts">
import { isTest } from '@shared/environment'

// Force repaint to make sure the animation is triggered correctly.
function forceRepaint (el: HTMLElement) {
  return getComputedStyle(el).height
}

function enter (el: HTMLElement) {
  el.style.transition = 'none'
  el.style.height = 'auto'

  const expandedHeight = el.scrollHeight

  el.style.height = '0'
  el.style.transition = ''

  forceRepaint(el)

  requestAnimationFrame(() => { el.style.height = `${expandedHeight}px` })
}

function afterEnter (el: HTMLElement) {
  el.style.height = 'auto'
}

function leave (el: HTMLElement) {
  const height = getComputedStyle(el).height

  el.style.height = height

  forceRepaint(el)

  requestAnimationFrame(() => { el.style.height = '0' })
}
</script>

<template>
  <slot v-if="isTest"/>
  <Transition v-else name="expand" @enter="enter as any" @afterEnter="afterEnter as any" @leave="leave as any">
    <slot/>
  </Transition>
</template>

<style scoped lang="scss">
* {
  backface-visibility: hidden;
  perspective: 1000px;
  transform: translateZ(0);
  will-change: height, opacity;
}
</style>

<style lang="scss">
.expand-enter-active,
.expand-leave-active {
  overflow: hidden;
  transition: height 0.25s ease-in-out;
  transition-property: opacity, height;
}

.expand-enter,
.expand-leave-to {
  height: 0;
  opacity: 0;
}
</style>
